import { useEffect, useMemo, useRef } from 'react';
import { BrowserQRCodeReader } from '@zxing/browser';
import { NotFoundException, ChecksumException, FormatException } from '@zxing/library';

export const useQrReader = (props) => {

  const {facingMode, scanDelay, onResult, onError, videoRef, active} = props

  const readerControls = useRef(null)

  const codeReader = useMemo(() => {
    return new BrowserQRCodeReader(null, {
      delayBetweenScanAttempts: scanDelay
    });
  }, [scanDelay])

  useEffect(() => {
    const setup = async () => {
      try {
        BrowserQRCodeReader.releaseAllStreams()

        await codeReader.decodeFromConstraints({video: {facingMode}}, videoRef.current, (result, error, controls) => {
          readerControls.current = controls

          if (result) {
            onResult(result)
          } else {
            const isChecksumError = error instanceof ChecksumException;
            const isNotFound = error instanceof NotFoundException;
            const isFormatError = error instanceof FormatException;

            if (!isChecksumError && !isNotFound && !isFormatError) {
              onError(error)
            }
          }
        })
      } catch (error) {
        onError(error)
      }
    }

    if (active) {
      setup()
    } else {
      readerControls.current?.stop()
    }

    return () => {
      readerControls.current?.stop()
    }
  }, [facingMode, active])

};
